import React, { Component } from "react";
import { connect } from 'react-redux';
import { Title, Body, Subtitle } from '@vds/typography';
import { Line } from '@vds/lines';
import { TextLink } from '@vds/buttons';
import { Grid, Row, Col } from '@vds/grids';
// import { refreshChatHashTag } from '../../utils/common';
import './ThankYou.css';
import { isMobile } from "react-device-detect";


class ThankYou extends Component {
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
    }


    componentDidMount() {
        const { pathname } = window.location;
        if (pathname.indexOf('Thank-you') > -1) {
            window.history.pushState(null, null, window.location.href);
            window.onpopstate = function () {
                window.history.go(1);
            };
        }
    }

    render() {
        return (
            <Grid className="Ty-page" colGutter={true}>
                <Row>
                    <Col colSizes={{ "mobile": 4, "tablet": 8, "desktop": 12 }}>
                        <div className="Ty-page-title">
                            <Title size="large" primitive="h2">
                                
                                 <span> Thank you for contacting Verizon {!isMobile ? <br/> : <></>}Business Markets </span>
                            </Title>
                            <div className="Ty-st-content">
                                <Subtitle size="medium" primitive="h2">
                                        <span> Your request has been submitted and a Sales representative will contact you within one business day. </span>
                                </Subtitle>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Grid>

        );
    }

}

// const mapStateToProps = (state) => {
//     const { CheckoutPage, Confirmation, ReviewOrderPage, CustomizeOrder, AddressValidationPage } = state;
//     return {
//         firstName: CheckoutPage?.contactInfo?.firstName || '',
//         isJointOfferAttempted: AddressValidationPage?.isJointOfferAttempted,
//         lastName: CheckoutPage?.contactInfo?.lastName || '',
//         address: CheckoutPage?.contactInfo?.address || '',
//         zipCode: CheckoutPage?.contactInfo?.zipCode || '',
//         city: CheckoutPage?.contactInfo?.city || '',
//         state: CheckoutPage?.contactInfo?.state || '',
//         companyName: CheckoutPage?.contactInfo?.businessName || '',
//         orderNumber: Confirmation?.getConfiramtionOrderInfoResponse?.Ord?.svc_orderNo || '',
//         dueDate: CheckoutPage?.dueDate || '',
//         timeSlotCode: CheckoutPage?.timeSlotCode || '',
//         appointmentCode: CheckoutPage?.appointmentCode || '',
//         orderInfo: Confirmation?.getConfiramtionOrderInfoResponse?.Ord,
//         cartInfo: ReviewOrderPage?.getCartInfoSuccessResponse,
//         floatCartResponse: CustomizeOrder.getFloatCartResponse,
//         nextButtonCC: CheckoutPage?.nextButtonCC,
//         creditCheck: CheckoutPage?.creditCheck,
//         jointOfferAvailResponse: CustomizeOrder.jointOfferAvailResponse,
//     };
// };

// const mapDispatchToProps = (dispatch) => ({
//     getOrderStatus: () => {
//         dispatch(getConfirmationOrder());
//     },
//     //for chat integration
//     getChatInfo: (data) => dispatch(getChatInfo(data)),

// });
// ThankYou = connect(mapStateToProps, mapDispatchToProps)(Confirmation);
export default ThankYou;